import { z } from 'zod'

export const ThemeId = z.enum(['editorial', 'minimal', 'playful'])
export type ThemeId = z.infer<typeof ThemeId>

export const PaymentMethods = z.object({
  iban: z.string().nullable(),
  bic: z.string().nullable(),
  ibanHolder: z.string().nullable(),
  lydiaPhone: z.string().nullable(),
  weroPhone: z.string().nullable(),
  paypalEmail: z.string().email().nullable(),
})
export type PaymentMethods = z.infer<typeof PaymentMethods>

export const CreateRegistryRequest = z.object({
  title: z.string().min(1).max(200),
  slug: z.string().min(3).max(40),
  dueDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
})
export type CreateRegistryRequest = z.infer<typeof CreateRegistryRequest>

export const UpdateRegistryRequest = z
  .object({
    title: z.string().min(1).max(200),
    dueDate: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .nullable(),
    welcomeMessage: z.string().max(2000).nullable(),
    coverImageId: z.string().nullable(),
    theme: ThemeId,
    accentColor: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/)
      .nullable(),
    iban: z.string().max(64).nullable(),
    bic: z.string().max(16).nullable(),
    ibanHolder: z.string().max(200).nullable(),
    lydiaPhone: z.string().max(32).nullable(),
    weroPhone: z.string().max(32).nullable(),
    paypalEmail: z.string().email().nullable(),
    extraNotificationEmails: z.array(z.string().email()).max(10),
  })
  .partial()
export type UpdateRegistryRequest = z.infer<typeof UpdateRegistryRequest>

export const CheckSlugResponse = z.object({
  available: z.boolean(),
  suggestions: z.array(z.string()),
})
export type CheckSlugResponse = z.infer<typeof CheckSlugResponse>

export const Registry = z.object({
  id: z.string(),
  slug: z.string(),
  status: z.enum(['draft', 'published']),
  title: z.string(),
  dueDate: z.string().nullable(),
  welcomeMessage: z.string().nullable(),
  coverImageUrl: z.string().url().nullable(),
  theme: ThemeId,
  accentColor: z.string().nullable(),
  paymentMethods: PaymentMethods,
  extraNotificationEmails: z.array(z.string().email()),
  members: z.array(
    z.object({ userId: z.string(), email: z.string().email(), displayName: z.string().nullable() }),
  ),
  pendingInvites: z.array(z.object({ id: z.string(), email: z.string().email() })),
  createdAt: z.number(),
  publishedAt: z.number().nullable(),
})
export type Registry = z.infer<typeof Registry>
